/*
 * Die Liste der Kurs-Auswertung kommt vollständig vom Server; eingeschränkt
 * wird im Browser. Ohne Modelle und ohne React, damit es sich einzeln
 * prüfen lässt.
 */

export const STAGE_OPTIONS = [
	{ value: 'withCompletion', label: 'At least one completion' },
	{ value: 'allDone', label: 'All members completed' },
	{ value: 'atCap', label: 'Cap reached' },
	{ value: 'none', label: 'No completion yet' }
]

const passtStufe = (zeile, stufe) => {
	const fertig = Number(zeile.completed) || 0
	const mitglieder = Number(zeile.members) || 0
	if (stufe === 'withCompletion') return fertig > 0
	if (stufe === 'allDone') return mitglieder > 0 && fertig >= mitglieder
	if (stufe === 'atCap') return Boolean(zeile.atCap)
	if (stufe === 'none') return fertig === 0
	return true
}

const enthaelt = (wert, suche) =>
	String(wert || '')
		.toLowerCase()
		.includes(suche)

/**
 * @param rows   Zeilen aus `companies`
 * @param query  `filters.query` — { stage?: [], state?: [], companyType?: [] }
 * @param search Suchtext (Name der Junior Company oder Schule)
 */
export const filterCompanies = (rows, query = {}, search = '') => {
	const suche = String(search || '')
		.trim()
		.toLowerCase()

	return rows.filter(zeile => {
		if (query.stage?.length && !query.stage.some(stufe => passtStufe(zeile, stufe))) return false
		if (query.state?.length && !query.state.includes(zeile.state)) return false
		if (query.companyType?.length && !query.companyType.includes(zeile.companyType)) return false
		if (suche && !enthaelt(zeile.name, suche) && !enthaelt(zeile.schoolName, suche)) return false
		return true
	})
}
